import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Inspection", copy: "We inspect the property after the tenant vacates." },
  { n: "02", title: "Condition Report", copy: "Damages, missing items, cleaning requirements and maintenance issues — documented." },
  { n: "03", title: "Make-Ready", copy: "Deep cleaning, pest control, plumbing, electrical, painting, carpentry, hardware, appliances, curtains, minor civil and furniture repairs." },
  { n: "04", title: "Final Presentation", copy: "The property is prepared and presented for the next tenant." },
  { n: "05", title: "Re-Rental", copy: "Photographs, listing preparation, enquiries, screening, agreement coordination and move-in." },
];

export const Lifecycle = () => (
  <section className="border-y border-navy-900/10 bg-white py-24 sm:py-32" data-testid="lifecycle-section">
    <div className="container-site">
      <SectionHeading
        chapter="04"
        eyebrow="The Complete Tenant Lifecycle"
        title="Tenant Vacated? We Take It From Here."
        copy="The gap between tenants is where remote ownership usually breaks down. We run the entire transition — you watch it happen through photos and reports."
      />

      <div className="relative mt-16">
        <div className="absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-gold-500/10 via-gold-500/50 to-gold-500/10 lg:block" aria-hidden="true" />
        <Stagger className="grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6" gap={0.12}>
          {STEPS.map((s) => (
            <StaggerItem key={s.n}>
              <div className="group relative" data-testid={`lifecycle-step-${s.n}`}>
                <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-gold-500/40 bg-white font-display text-sm font-extrabold text-gold-600 transition-colors duration-300 group-hover:bg-gold-500 group-hover:text-navy-900">
                  {s.n}
                </span>
                <h3 className="mt-5 font-display text-lg font-extrabold tracking-tight text-navy-900">{s.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-muted-foreground">{s.copy}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-14 flex flex-wrap items-center gap-4">
          <Link to="/property-make-ready" className="btn-navy" data-testid="lifecycle-cta">
            See the Make-Ready Process <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
